import { PaymentOptionModel } from "../../payment/payment-option-model";

export class CashRegisterPaymentStartRequest {
    requestType?: string;
    orderId?: number;
    customerId?: number;
    cashRegisterId?: number;
    isWaitForPayment?: boolean;
    paymentOptions?: PaymentOptionModel[];
    accessToken?: string;
    changeSum?: number;

}